<template>
  <router-view />
</template>

<script>
import api from '@/services/api';
import 'vue-multiselect/dist/vue-multiselect.min.css';

export default {
  name: 'App',
  mounted() {
    api.api.interceptors.response.use(
      (conf) => conf,
      (error) => {
        // If any api request returns status of 401 redirect it to login
        if (error?.response?.status === 401) {
          localStorage.removeItem('token');
          const redirectTo = window.location.href;

          if (!redirectTo.includes('login')) {
            this.$router.push({
              name: 'Login',
              query: {
                redirectTo,
              },
            });
          }
        }
        return Promise.reject(error);
      },
    );

    this.disableImageDownloading();
  },
  methods: {
    disableImageDownloading() {
      $(document).on('contextmenu', 'img', () => false);
      $(document).on('mousedown', 'img', () => false);
    },
  },
};
</script>

<style lang="scss">
.Vue-Toastification__toast--info {
  background: #1e84bc;
  color: #fff;
}

// Vue select
.multiselect__tags {
  border-radius: 0;
  padding: 11px 40px 3px 8px;
}
.multiselect__select {
  height: 45px;
}

.multiselect__option--highlight {
  background: #e0e0e0;
  color: #555;
}

.multiselect__option--highlight:after {
  background: #e0e0e0;
  color: #555;
}

.multiselect__tag {
  background: #1e84bc
}

.multiselect__tag-icon:after {
  color: #fff;
}
</style>
